import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  root: {
    color: '#515151',
  },
}))(Typography);
